import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';

@Component({
    selector: 'app-idle-warning-dialog',
    templateUrl: './idle-warning-dialog.component.html',
    styleUrls: ['./idle-warning-dialog.component.css']
})
export class IdleWarningDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { seconds: number },
        private ref: MatDialogRef<IdleWarningDialogComponent>
    ) { }

    close() {
        this.ref.close();
    }
}